// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#send-document-category-list[data-v-a676d108]{max-width:1280px;margin-left:auto;margin-right:auto}#send-document-category-list .cancel-btn[data-v-a676d108],#send-document-category-list .update-btn[data-v-a676d108]{width:120px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
